import { ProductType } from '../../../common';
import { FromPrice, getPricesByIds, SFCCPricingSearchResult } from '../..';

export const getFamilyPrices = async (familyIds: number[]): Promise<FromPrice[] | null> => {
  try {
    const prices = await getPricesByIds<FromPrice[] | SFCCPricingSearchResult>(
      familyIds,
      ProductType.Family
    );

    if (!prices) {
      console.warn(`No prices found for familyIds: ${familyIds}`);
      return null;
    }

    const sfccPrice = (prices as SFCCPricingSearchResult)?.search_phrase_suggestions?.c_prices;
    const fromPrice = prices as FromPrice[];

    return sfccPrice || fromPrice || null;
  } catch (error) {
    console.error(`Error fetching families prices:`, error);
    return null;
  }
};
